import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Dialog from '../../Dialog';
import Button from '../../Button';
import ConfirmAction from '../ConfirmAction';

const EpisodeOfCareDetails = ({
  title,
  visible,
  onCancel,
  onSave,
  onSaveAndProcess,
  onDelete,
  isEditable,
  children,
  isValid,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [
    isConfirmSaveAndProcessDialogOpen,
    setIsConfirmSaveAndProcessDialogOpen,
  ] = useState(false);
  const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] =
    useState(false);

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    } else {
      onCancel();
    }
    setIsConfirmDeleteDialogOpen(false);
  };

  const handleConfirmDelete = () => {
    setIsConfirmDeleteDialogOpen(true);
  };

  const handleConfirm = () => {
    setIsConfirmSaveAndProcessDialogOpen(true);
  };

  const handleSaveAndProcess = () => {
    onSaveAndProcess();
    setIsConfirmSaveAndProcessDialogOpen(false);
  };

  return (
    <>
      <Dialog
        title={title}
        visible={visible}
        onCancel={onCancel}
        footer={
          isEditable ? (
            <div className="flex-1 cluster-2 justify-between">
              <Button type="danger" onClick={handleConfirmDelete}>
                Delete
              </Button>
              <Button
                type="primary"
                onClick={handleConfirm}
                disabled={!isValid}
              >
                Save & Process
              </Button>
            </div>
          ) : null
        }
      >
        {children}
      </Dialog>
      <ConfirmAction
        open={isConfirmSaveAndProcessDialogOpen}
        title="Save & Process"
        message="Please confirm you would like to process this record. This action is irreversible."
        onCancel={() => setIsConfirmSaveAndProcessDialogOpen(false)}
        onOk={handleSaveAndProcess}
      />
      <ConfirmAction
        open={isConfirmDeleteDialogOpen}
        title="Delete Record"
        message="Please confirm you would like to delete this record. This action is irreversible."
        onCancel={() => setIsConfirmDeleteDialogOpen(false)}
        okType="danger"
        onOk={handleDelete}
      />
    </>
  );
};

EpisodeOfCareDetails.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  isEditable: PropTypes.bool,
};

EpisodeOfCareDetails.defaultProps = {
  visible: false,
  onCancel: () => {},
  isEditable: false,
};

export default EpisodeOfCareDetails;
